import React from 'react';

export function StarterFeeding() {
  return (
    <div className="space-y-6 text-white/90" style={{ userSelect: "none" }}>
      <div className="bg-gray-600/60 p-6">
        <h3 className="text-xl text-white mb-4">Feeding Your Sourdough Starter</h3>
        <p className="mb-4">
          Proper feeding is essential for maintaining a healthy, active sourdough starter. A well-fed starter will produce better bread with consistent results. This guide covers everything you need to know about feeding routines, ratios, and troubleshooting common issues.
        </p>
      </div>
      
      <div className="bg-gray-600/60 p-6">
        <h3 className="text-xl text-white mb-4">Basic Feeding Guidelines</h3>
        <div className="space-y-4">
          <div className="bg-white/5 p-4 rounded-lg">
            <h4 className="text-lg text-amber-400 mb-2">Standard Feeding Ratio</h4>
            <p className="text-sm text-white/80">
              The most common feeding ratio is 1:1:1 (starter:flour:water by weight)
            </p>
            <ul className="list-disc list-inside text-sm text-white/80 mt-2">
              <li>100g mature starter</li>
              <li>100g flour</li>
              <li>100g water</li>
            </ul>
          </div>
          
          <div className="bg-white/5 p-4 rounded-lg">
            <h4 className="text-lg text-amber-400 mb-2">Feeding Schedule</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Room temperature: Feed every 12-24 hours</li>
              <li>Refrigerated: Feed every 1-2 weeks</li>
              <li>Before baking: Feed 2-3 times at 12-hour intervals</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-gray-600/60 p-6">
        <h3 className="text-xl text-white mb-4">Signs of a Healthy Starter</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h4 className="text-lg text-amber-400 mb-2">Positive Signs</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Doubles in size within 4-8 hours</li>
              <li>Bubbles throughout the mixture</li>
              <li>Pleasant, fruity aroma</li>
              <li>Regular rise and fall pattern</li>
              <li>Passes the float test</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg text-amber-400 mb-2">Warning Signs</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Pink or orange coloring</li>
              <li>Strong acetone smell</li>
              <li>Mold growth</li>
              <li>No activity after feeding</li>
              <li>Excess liquid (hooch)</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-gray-600/60 p-6">
        <h3 className="text-xl text-amber-400 mb-4">Troubleshooting Common Issues</h3>
        <div className="space-y-4">
          <div>
            <h4 className="text-lg text-white mb-2">Starter Not Rising</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Feed more frequently (every 12 hours)</li>
              <li>Use warmer water (80-85°F)</li>
              <li>Keep in a warmer location</li>
              <li>Try adding some whole grain flour</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg text-white mb-2">Liquid on Top (Hooch)</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Feed more frequently</li>
              <li>Pour off liquid and feed as usual</li>
              <li>Use cooler water</li>
              <li>Reduce hydration slightly</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}